const baseURL = process.env.REACT_APP_BASE_URL;
const BEARER_TOKEN = process.env.REACT_APP_BEARER_TOKEN;
// Agronomist onboarding portal host — hoisted out of NavigationBar's per-agronomist
// URL map so adding an agronomist is a slug change, not a code deploy of full URLs.
const MANAGE_BASE_URL = process.env.REACT_APP_MANAGE_BASE_URL || 'https://manage.phyfarm.com';
// Fixed public API host — the prod target of the per-page env toggle (useEnvironmentToggle).
// Deliberately a literal, not env-driven: the toggle exists to reach the known prod host
// regardless of which env the bundle was built for.
const PROD_BASE_URL = 'https://v3.api.phyfarm.com';

export { baseURL, BEARER_TOKEN, MANAGE_BASE_URL, PROD_BASE_URL };
